export enum AdminPanelEventsEnum {
    eventEvents = 'adminPanel/eventEvents'
}

export type AdminPanelEventType = 'save' | 'back' | 'onGrey' | 'onGreen';

export const getAdminPanelEventName = (eventName: AdminPanelEventsEnum, type: AdminPanelEventType) => {
    return eventName.toString() + '_' + type;
}